module.exports = __webpack_public_path__ + "static/media/Title.fa38e9b7.png";